function getBundledLineItemProductVariant(bundleLineItem) {
  return bundleLineItem.legacyProduct.masterData.current.variant;
}
export {
  getBundledLineItemProductVariant
};
//# sourceMappingURL=get-bundled-line-item-product-variant.js.map
